import {
  Table,
  Input,
  Button,
  Modal,
  Space,
  Card,
  Row,
  Col,
  Typography,
  Tag,
  Tooltip,
  Spin,
  Divider,
  message,
} from "antd";
import {
    SearchOutlined,
    CloseOutlined,
    MailOutlined,
    ClockCircleOutlined,
    DeleteOutlined,
    LoadingOutlined
} from '@ant-design/icons';
import { Box } from "@strapi/design-system/Box";
import { Flex } from "@strapi/design-system/Flex";
import { IconButton } from "@strapi/design-system/IconButton";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getEmailLogs, getEmailDetail } from "../util/API";
import Sidebar from "./layout/Sidebar";
import dayjs from "dayjs";
import { set } from "lodash";


const EmailManagement = () => {
    const { t } = useTranslation();
    const [emailLogs, setEmailLogs] = useState([]);
    const [pageSize, setPageSize] = useState(25);
    const [showDetail, setShowDetail] = useState(false);
    const [emailDetail, setEmailDetail] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedEmail, setSelectedEmail] = useState(null);
    const [totalRows, setTotalRows] = useState(0);
    const [modalVisible, setModalVisible] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [loading, setLoading] = useState(false);
    const [searchTimeout, setSearchTimeout] = useState(null);
    const [messageApi, contextHolder] = message.useMessage();

    useEffect(() => {
      fetchEmailLogs(); 
    }, [currentPage, pageSize]);

    const fetchEmailLogs = async (searchText = "") => {
    try {
      const response = await getEmailLogs(currentPage, pageSize, searchText);

      const items = response?.data?.data || [];
      const total = response?.data?.meta?.pagination?.total || 0;

      setEmailLogs(items);
      setTotalRows(total);

    } catch (error) {
      console.error("Error fetching emails:", error);
    }
  };

      
  const handleSearch = (value) => {
    setSearchText(value);
    if (searchTimeout) clearTimeout(searchTimeout);
    const timeout = setTimeout(() => {
      fetchEmailLogs(value); 
    }, 500);

    setSearchTimeout(timeout);
  };

    const handlePageChange = (page, pageSize) => {
        setCurrentPage(page);
        setPageSize(pageSize);
    };

    const handleViewEmail = async (id) => {
      try {
        const response = await getEmailDetail(id);
        setSelectedEmail(response.data.data);
        setModalVisible(true);
      } catch (error) {
        console.error("Error fetching email detail:", error);
      } 
    };

    const getStatusColor = (status) => {
        switch (status) {
            case "success":
                return "green";
            case "pending":
                return "black";
            case "error":
                return "red";
            default:
                return "black";
        }
    }

    const columns = [
        {
            title: `${t("str_ordinal_number")}`,
            key: "index",
            render: (value, record, index) => (currentPage - 1) * pageSize + index + 1,
        },
        {
            title: `${t("str_title_email")}`,
            dataIndex: ["attributes", "title"],
        },
        {
            title: `${t("str_recipient")}`,
            dataIndex: ["attributes", "to"],
        },
        {
            title: `${t("str_sender")}`,
            dataIndex: ["attributes", "from"],
        },
        {
            title: `${t("str_state")}`,
            dataIndex: ["attributes", "state"],
            render: (value) => <span style={{ color: getStatusColor(value) }}>{value}</span>,
        },
        {
            title: `${t("str_sent_at")}`,
            dataIndex: ["attributes", "send_at"],
            render: (date) =>
                date ? dayjs(date).format("YYYY-MM-DD HH:mm:ss") : "N/A",
        },
        {
            title: `${t("str_action")}`,
            key: "action",
            render: (text, record) => (
                <IconButton
                    icon={<MailOutlined />}
                    label={t("str_view_detail")}
                    onClick={() => handleViewEmail(record.id)}
                />
            ),
        },
    ];

  

    return (
        <div>
          {contextHolder}
          <div>
            <div className="main-wrapper">
              <Sidebar role={{ type: "secretariat" }} key={"email_management"} />
    
              <div className="main-panel-lg">
                <Card title={t("str_email_management")}>
                    <Box paddingBottom={4}>
                        <div style={{ marginBottom: 16, display: 'flex' }}>
                          <Input
                            placeholder={t("str_search_by_recipient_email")}
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                            onPressEnter={() => fetchEmailLogs(searchText)}
                            style={{ width: 300 }}
                            prefix={<SearchOutlined />}
                            allowClear
                          />
                        </div>
                        <Table
                            rowKey="id"
                            columns={columns}
                            dataSource={emailLogs}
                            loading={loading}
                            pagination={{
                                current: currentPage,
                                pageSize,
                                total: totalRows,
                                onChange: setCurrentPage,
                            }}
                            scroll={{ x: "1000px", y: 500 }}
                            locale={{
                                emptyText: (
                                    <div style={{ textAlign: "center", padding: 40 }}>
                                        <LoadingOutlined style={{ fontSize: 24 }} />
                                        <p>{t("str_no_data")}</p>
                                    </div>
                                ),
                            }}
                        />
                    </Box>
                </Card>
              </div>
            </div>
          </div>
          {/* Modal xem chi tiết email */}
          <Modal
            title={selectedEmail?.attributes?.title || t("str_email_details")}
            open={modalVisible}
            onCancel={() => setModalVisible(false)}
            footer={[
              <Button key="close" size="large" onClick={() => setModalVisible(false)}>
                {t("str_close")}
              </Button>
            ]}
            width={1100}
            style={{ top: 20 }}
            bodyStyle={{ maxHeight: 'calc(100vh - 200px)', overflowY: 'auto' }}
          >
            {selectedEmail ? (
              <>
                <div style={{ background: '#f5f5f5', padding: 20, borderRadius: 8, marginBottom: 16 }}>
                  <Row gutter={[16, 16]}>
                    <Col span={4}><Typography.Text strong style={{ fontSize: '16px' }}>{t("str_from")}:</Typography.Text></Col>
                    <Col span={20}><Typography.Text style={{ fontSize: '16px' }}>{selectedEmail.from}</Typography.Text></Col>
                    
                    <Col span={4}><Typography.Text strong style={{ fontSize: '16px' }}>{t("str_to")}:</Typography.Text></Col>
                    <Col span={20}><Typography.Text style={{ fontSize: '16px' }}>{selectedEmail.to}</Typography.Text></Col>
                    
                    <Col span={4}><Typography.Text strong style={{ fontSize: '16px' }}>{t("str_sent_at")}:</Typography.Text></Col>
                    <Col span={20}>
                      <Typography.Text style={{ fontSize: '16px' }}>
                        {selectedEmail.send_at 
                          ? dayjs(selectedEmail.send_at).format("YYYY-MM-DD HH:mm:ss") 
                          : "N/A"}
                      </Typography.Text>
                    </Col>
                    
                    <Col span={4}><Typography.Text strong style={{ fontSize: '16px' }}>{t("str_status")}:</Typography.Text></Col>
                    <Col span={20}>
                      <Tag color={getStatusColor(selectedEmail.state)} style={{ fontSize: '14px', padding: '2px 10px' }}>
                        {selectedEmail.state || "N/A"}
                      </Tag>
                    </Col>
                  </Row>
                </div>

                <Divider style={{ margin: '16px 0' }} />
                <div style={{ padding: '0 10px' }}>
                  {selectedEmail.body.html ? (
                    <div 
                      dangerouslySetInnerHTML={{ __html: selectedEmail.body.html }}
                      style={{ fontSize: '18px', lineHeight: '1.8' }}
                    />
                  ) : (
                    <Typography.Text style={{ fontSize: '18px' }}>{t("str_no_content")}</Typography.Text>
                  )}
                </div>
              </>
            ) : (
              <div style={{ textAlign: "center", padding: 40 }}>
                <Spin size="large" />
              </div>
            )}
        </Modal>
    </div>
  );

};

export default EmailManagement;
